import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import kebabCase from "lodash/kebabCase";
import { withTheme } from "shared/context/theme";
import Submenu from "./Submenu";
import styles from "./styles.css";
import themes from "./themes";

class TextItem extends Component {
  constructor(props) {
    super(props);

    this.submenu = React.createRef();
    this.state = { isSubmenuOpen: false };
  }

  getIsActive = () => {
    if (typeof window === "undefined") return false;
    const { url } = this.props;

    // Item is active when current location & item's URL match
    return !!window.location.href.match(url);
  };

  handleDocumentTouchEnd = (event) => {
    document.removeEventListener("touchend", this.handleDocumentTouchEnd);

    // Emulates "mouseleave" behaviour for touch devices and
    // lets click events from inside the Subnav go through.
    if (!this.submenu.current.contains(event.target)) {
      this.closeSubmenu();
    }
  };

  handleItemTouchEnd = () => {
    const { submenu } = this.props;
    const { isSubmenuOpen } = this.state;

    if (submenu && !isSubmenuOpen) {
      document.addEventListener("touchend", this.handleDocumentTouchEnd);
      this.openSubmenu();
    }
  };

  handleItemMouseEnter = () => {
    const submenu = this.props;

    if (submenu) this.openSubmenu();
  };

  handleItemMouseLeave = () => {
    const submenu = this.props;

    if (submenu) this.closeSubmenu();
  };

  openSubmenu = () => {
    this.setState({ isSubmenuOpen: true });
  };

  closeSubmenu = () => {
    this.setState({ isSubmenuOpen: false });
  };

  render() {
    const {
      theme,
      title,
      url,
      children,
      submenu,
      className,
      activeClassName,
    } = this.props;

    const { isSubmenuOpen } = this.state;
    const isActive = this.getIsActive();

    const id = `${kebabCase(title)}-menu-desktop`;
    const label = `${kebabCase(title)}-heading-desktop`;
    const content = children || title;

    return (
      <div
        className={cn({
          [theme.styles.item]: true,
          [theme.styles.isSubmenuOpen]: isSubmenuOpen,
          [activeClassName || theme.styles.isActive]: isActive,
          [className]: className,
        })}
        id={label}
        aria-controls={submenu ? id : null}
        data-lpa-category="Destinations Next"
        data-lpa-action="Global Navigation Click"
        data-lpa-label={title}
        onTouchEnd={this.handleItemTouchEnd}
        onMouseEnter={this.handleItemMouseEnter}
        onMouseLeave={this.handleItemMouseLeave}
      >
        {submenu ? (
          <span className={theme.styles.link}>{content}</span>
        ) : (
          <a href={url} className={theme.styles.link}>
            {content}
          </a>
        )}
        {submenu && (
          <Submenu
            {...submenu}
            id={id}
            className={theme.styles.submenu}
            ref={this.submenu}
            aria-hidden={isSubmenuOpen ? "false" : "true"}
            aria-labelledby={label}
          />
        )}
      </div>
    );
  }
}

TextItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  url: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
  submenu: PropTypes.shape({}),
  children: PropTypes.element,
  className: PropTypes.string,
};

TextItem.defaultProps = {
  submenu: null,
  children: null,
  className: "",
};

export default withTheme(TextItem, styles, themes);
